export default __webpack_public_path__ + "static/TSD_Header_2_feautured-16e0db8428fa8a13f675e1b80cb53227.jpg";